import { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  closeModal,
  selectIsOpen,
  selectIsLast,
  getZIndex,
  startClosing,
  resetClosing,
} from "../../redux/Slice/modalSlice";
import { modalState } from "../../utils/constants";

import { Dialog } from "../Dialog";

const Modal = (props) => {
  const isOpen = useSelector(selectIsOpen(props.modal));
  const isLast = useSelector(selectIsLast(props.modal));
  const zIndex = useSelector(getZIndex);

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const closeModalHandler = useCallback(() => {
    dispatch(startClosing()); // Ставим флаг "идёт закрытие"
    // Через 300 мс сбрасываем флаг
    setTimeout(() => dispatch(resetClosing()), 300);

    dispatch(closeModal(props.modal));
  }, [dispatch, props.modal]);

  useEffect(() => {
    if (!isOpen) return;

    // Сохраняем текущий URL
    const originalUrl = window.location.href;

    // Добавляем новую запись в историю
    navigate("#modal", { replace: false });

    const handlePopState = (event) => {
      // Проверяем, была ли нажата кнопка "Назад"
      if (window.location.href === originalUrl) {
        closeModalHandler();
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      // Восстанавливаем URL если модальное окно закрыто не через back button
      if (window.location.hash === "#modal") {
        navigate(-1);
      }
    };
  }, [isOpen, closeModalHandler, navigate, props.modal]);

  return (
    <Dialog
      onClose={closeModalHandler}
      isListenClickOutside={
        props.modal === modalState.RELEASE_TEXT ? false : isLast
      }
      openingDirection={props.openingDirection}
      zIndex={zIndex}
      backgroundColor={props.backgroundColor}
      isOpen={isOpen}
      isLast={isLast}
      showBlackout={props.showBlackout}
      title={props.title}
      modalName={props.modal}
    >
      {props.children}
    </Dialog>
  );
};

export default Modal;
